// IdentityIntake — the wall's own overlay mount of ModelIntake (narcis wall plan step 4). Real
// narcis token names with fallbacks, matching this house's own `header.module.scss`/
// `IdentityPanel.module.scss` idiom.

.arena {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
}

.scrim {
    position: absolute;
    inset: 0;
    background: color-mix(in srgb, var(--bg, #0e0e10) 82%, transparent);
}

.panel {
    position: relative;
    width: min(920px, 100%);
    max-height: min(880px, 100%);
    overflow-y: auto;
    background: var(--surface, #18181b);
    border: 1px solid var(--border, #27272a);
    border-radius: var(--radius-xl, 20px);
    padding: 32px;
}

.close {
    position: sticky;
    top: 0;
    float: right;
    margin-left: 12px;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--border-med, #3f3f46);
    border-radius: var(--radius-full, 9999px);
    background: var(--surface-hover, #1f1f23);
    color: var(--text-muted, #a1a09a);
    cursor: pointer;
    z-index: 1;
}

.close:hover {
    color: var(--text, #faf9f7);
}

// The sheet's own full-height state, approximated (this file's own header note): below a phone
// width, the panel rises edge to edge rather than floating as a centred card.
@media (max-width: 640px) {
    .arena {
        padding: 0;
    }

    .panel {
        width: 100%;
        max-height: 100%;
        height: 100%;
        border-radius: 0;
        border-width: 0;
    }
}
